import { Toggle } from "../components/Toggle";
import { useSelector, useDispatch } from "react-redux";

export const ParameterToggle = ({ parameterHandler, label, labelSize, valueToBool, boolToValue, noLabel=false, colorizeLabel, className="", ...props }) => {

    const dispatch = useDispatch();
    const parameterValue = useSelector(parameterHandler.selector);
    const onNewValue = value => dispatch(parameterHandler.updater(boolToValue ? boolToValue(value) : value));
    
    if (!label && parameterHandler.description.label) label = parameterHandler.description.label;
    if (noLabel) label = undefined;

    return <Toggle {...props} checked={valueToBool ? valueToBool(parameterValue) : parameterValue} className={className} onNewValue={onNewValue} label={label} labelSize={labelSize} colorizeLabel={colorizeLabel}/>
};